import {backendRequest} from '../../../common/utils/requests'
import {PromotionEvent} from './types'

export async function recordPromotionEvent(campaignId: number, event: PromotionEvent): Promise<void> {
  const response = await backendRequest(`/api/v2/dashboard/promotions/${campaignId}/events`, event)
  if (!response.ok) throw new Error(`Could not record promotion event (${response.status})`)
}
